<app-navbar title="Usługi">
	<a routerLink="./add" class="btn btn-primary"> <i class="fas fa-plus"></i> Dodaj </a>
</app-navbar>

<app-services-list-filters
	userFilters="service-list"
	[forceFilters]="{ limit: 9999 }"
	[transport]="parameters.transport"
	(selected)="filtersSelected($event)"
></app-services-list-filters>

<app-dynamic-table-v2 [module]="'service'" [elements]="data" [columns]="columnsDef"></app-dynamic-table-v2>
